import { WPAcfBasic } from 'types/acf';
import { WPArticleEmbedded } from 'types/articles';
import { WPPageEmbedded } from 'types/pages';
import { WPTerm, WPTermType } from 'types/terms';

const getUniqueTermTypes = <T extends WPAcfBasic = WPAcfBasic>(terms: WPTerm<T>[]) => Array.from(new Set(terms.map(term => term.taxonomy)));

export const getTermType = <T extends WPAcfBasic = WPAcfBasic>(terms: WPTerm<T>[], type: WPTermType, callback?: (term: WPTerm<T>) => boolean) =>
  terms.filter(term => (callback ? callback(term) : term.taxonomy === type));

export const getArticleTerms = <T extends WPAcfBasic = WPAcfBasic>(embedded?: WPArticleEmbedded<T>, callback?: () => boolean) => {
  if (!embedded) {
    return {};
  }
  const { 'wp:term': terms = [] } = embedded;
  const flattenedTerms = terms.flat(2);
  const keys = getUniqueTermTypes(flattenedTerms);
  const uniqueTerms = keys.map(key => ({
    [key]: getTermType<T>(flattenedTerms, key, callback),
  }));
  return Object.assign({}, ...uniqueTerms) as Partial<Record<WPTermType, WPTerm<T>[]>>;
};

export const getArticleFeaturedImage = <T extends WPAcfBasic = WPAcfBasic>(embedded?: WPArticleEmbedded<T>) => {
  if (!embedded) {
    return [];
  }
  const { 'wp:featuredmedia': featuredMedia = [] } = embedded;
  return featuredMedia;
};

export const getArticleAuthor = <T extends WPAcfBasic = WPAcfBasic>(embedded?: WPArticleEmbedded<T> | WPPageEmbedded<T>) => {
  if (!embedded) {
    return [];
  }
  const { author } = embedded;
  return author || [];
};
